import axiosInstance from "../../axios/axios";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";

export const GetPreventiveGuidelinesApi = async () => {
  const response = await axiosInstance.get("/vozo/preventiveguidelines/list");
  return Decrypt_Value(response.data, "vozo");
};

export const GetPreventiveFrequencyOptionsApi = async () => {
  const response = await axiosInstance.get(
    "/vozo/preventiveguidelines/frequencies",
  );
  return Decrypt_Value(response.data, "vozo");
};

export const CreatePreventiveGuidelineApi = async (payload) => {
  const response = await axiosInstance.post(
    "/vozo/preventiveguidelines/create",
    Encrypt_Value(payload, "vozo"),
  );

  return Decrypt_Value(response.data, "vozo");
};

export const EditPreventiveGuidelineApi = async (payload) => {
  const response = await axiosInstance.post(
    "/vozo/preventiveguidelines/edit",
    Encrypt_Value(payload, "vozo"),
  );

  return Decrypt_Value(response.data, "vozo");
};

export const UpdatePreventiveGuidelineApi = async (payload) => {
  const response = await axiosInstance.post(
    "/vozo/preventiveguidelines/update",
    Encrypt_Value(payload, "vozo"),
  );

  return Decrypt_Value(response.data, "vozo");
};

export const DeletePreventiveGuidelineApi = async (payload) => {
  const response = await axiosInstance.post(
    "/vozo/preventiveguidelines/delete",
    Encrypt_Value(payload, "vozo"),
  );

  return Decrypt_Value(response.data, "vozo");
};

export const TogglePreventiveGuidelineStatusApi = async (payload) => {
  const response = await axiosInstance.post(
    "/vozo/preventiveguidelines/toggle-status",
    Encrypt_Value(payload, "vozo"),
  );

  return Decrypt_Value(response.data, "vozo");
};
